module.exports = __webpack_public_path__ + "img/9.8eb5f9bb.jpg";